import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startBranchListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Các vùng chính của trang chi nhánh.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-branches-header"]', "Tiêu đề trang", "Hiển thị module quản lý chi nhánh và nút tour.", "bottom"],
    ['[data-tour="hrm-branches-filter"]', "Bộ lọc", "Lọc theo từ khóa, loại chi nhánh, trạng thái và thao tác thêm mới.", "bottom"],
    ['[data-tour="hrm-branches-dashboard"]', "Mini dashboard", "Theo dõi nhanh các chỉ số chi nhánh và lọc nhanh theo thẻ.", "bottom"],
    ['[data-tour="hrm-branches-table"]', "Danh sách chi nhánh", "Mobile: card từng chi nhánh. Desktop: bảng chi tiết, trạng thái và thao tác.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
